const Search = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="11.5" r="6.75" stroke="#1A1919" strokeWidth="1.5" />
      <path
        d="M19.4697 20.5303C19.7626 20.8232 20.2374 20.8232 20.5303 20.5303C20.8232 20.2374 20.8232 19.7626 20.5303 19.4697L19.4697 20.5303ZM16.5 16.5L15.9697 17.0303L19.4697 20.5303L20 20L20.5303 19.4697L17.0303 15.9697L16.5 16.5Z"
        fill="#1A1919"
      />
    </svg>
  );
};

export default Search;
